<template>
  <!-- 盘点单弹窗 -->
  <div>
    <BaseDialog title="盘点" @handleShow="(val) => {pdListDialog = val }" :isshow="pdListDialog" width="500px"
      height="auto">
      <div class="addform" style="margin-top:10px;">
        <el-form :model="pdList" ref="ruleFormPdRef" label-width="120px">
          <el-row>
            <el-col :span="23">
              <el-form-item label="盘点时间：">
                <el-date-picker v-model="pdList.check_date" type="date" value-format="YYYY-MM-DD" placeholder="请选择盘点日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="23">
              <el-form-item label="备注：">
                <el-input type="textarea" v-model="pdList.remark" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="text-align: right">
        <el-button @click="cancelPdList">取消</el-button>
        <el-button type="primary" @click="handlePdList()" :loading="saveLoad">确定</el-button>
      </div>
    </BaseDialog>
  </div>
</template>

<script setup>
  import {
    reactive,
    ref,
    onMounted,
    defineExpose,
    defineEmits,
    nextTick,
  } from 'vue'
  import service from '@/utils/request'
  import BaseDialog from '@/components/Dialog/index.vue'
  import { ElMessage } from 'element-plus'
  import { gitDictList, TimeYear, downLoadXlsx, TimestampToTime } from '@/utils/tool'
  const pdList = ref({})
  const pdListDialog = ref(false)
  const dictCatalogType = ref('')
  const saveLoad = ref(false)
  onMounted(() => {

  })
  const initData = (id) => {
    pdListDialog.value = true
    saveLoad.value = false
    dictCatalogType.value = id
    pdList.value.check_date = TimestampToTime()
  }
  //取消盘点单
  const cancelPdList = () => {
    pdListDialog.value = false
    pdList.value = {}
  }
  const em = defineEmits(['refreshDataList'])
  const handlePdList = async () => {
    saveLoad.value = true
    let data = {
      dict_catalog_type: dictCatalogType.value,
      ...pdList.value
    }
    let res = await service.post('/api/storeDrugCheck/createOrder', data)
    if (res.code === 0) {
      saveLoad.value = false
      pdList.value = {}
      pdListDialog.value = false
      em('refreshDataList',res.data.check_order_id,true)
    }else{
      saveLoad.value = false
    }
  }
  defineExpose({
    initData,
    cancelPdList,
    handlePdList
  })
</script>

<style scoped lang="scss">
  .consumables-search {
    margin-top: 16px;

    .el-form-item {
      width: 95%;
    }
  }
</style>